var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons - Outline/Status indicators/error-circle/2px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,66.75 L48,45.75 L45.8333333,45.75 C44.7287638,45.75 43.8333333,44.8545695 43.8333333,43.75 C43.8333333,42.6454305 44.7287638,41.75 45.8333333,41.75 L50,41.75 C51.1045695,41.75 52,42.6454305 52,43.75 L52,66.75 L54.1666667,66.75 C55.2712362,66.75 56.1666667,67.6454305 56.1666667,68.75 C56.1666667,69.8545695 55.2712362,70.75 54.1666667,70.75 L45.8333333,70.75 C44.7287638,70.75 43.8333333,69.8545695 43.8333333,68.75 C43.8333333,67.6454305 44.7287638,66.75 45.8333333,66.75 L48,66.75 Z M50,91.5833333 C27.0341592,91.5833333 8.41666667,72.9658408 8.41666667,50 C8.41666667,27.0341592 27.0341592,8.41666667 50,8.41666667 C72.9658408,8.41666667 91.5833333,27.0341592 91.5833333,50 C91.5833333,72.9658408 72.9658408,91.5833333 50,91.5833333 Z M50,87.5833333 C70.7567018,87.5833333 87.5833333,70.7567018 87.5833333,50 C87.5833333,29.2432982 70.7567018,12.4166667 50,12.4166667 C29.2432982,12.4166667 12.4166667,29.2432982 12.4166667,50 C12.4166667,70.7567018 29.2432982,87.5833333 50,87.5833333 Z M48.9583333,34.8125 C47.2784672,34.8125 45.9166667,33.4506994 45.9166667,31.7708333 C45.9166667,30.0909672 47.2784672,28.7291667 48.9583333,28.7291667 C50.6381994,28.7291667 52,30.0909672 52,31.7708333 C52,33.4506994 50.6381994,34.8125 48.9583333,34.8125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage-numbers.v3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.RemoveNumber",
    transform: "translate(-678.000000, -268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83E\\uDDE9-Components/Dialogs/Desktop/Blank/1-CTA-+-Back",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(170.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Colour-mask/Status/info-circle/4px",
    transform: "translate(500.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colour/Grey-7-(#4A4D4E)",
    mask: "url(#mask-2)",
    fill: "#4A4D4E",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.252d41ad3ff305edd7ca9d0e8cf06650.svg";
export { ForwardRef as ReactComponent };